const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const track = (type, name = "") => {
  try {
    fetch(`${API}/analytics/event`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        type,
        name,
        path: window.location.pathname,
        referrer: document.referrer,
        lang: localStorage.getItem("ltc_lang") || "pt",
      }),
    });
  } catch { /* analytics must never break the page */ }
};
